import { USER_DATA_QUERY_KEY } from '@/shared/constants/queryKeys';

export const USER_QUERY_KEYS = {
  account: ['account'],
  cognitoUser: ['cognitoUser'],
  userApiKey: ['userApiKey'],
  userData: USER_DATA_QUERY_KEY,
  userSettings: (isAuthenticated = false, spaceId = '', isSuperUser = false) => [
    'userSettings',
    isAuthenticated,
    spaceId,
    isSuperUser,
  ],
} as const;
